import { Component } from "@angular/core";
import { Action } from "src/app/components/ui/actions/action";

@Component({
  selector: "snt-action-seprator",
  template: "",
  providers: [{ provide: Action, useExisting: ActionSeparatorComponent }],
  standalone: false
})
export class ActionSeparatorComponent extends Action {
  isSeparator = true;
}
